module.exports = global["WHITEROOM"] = require("-!.\\Main.js");